// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"354":"ff5fb5c9","704":"692bb5d2","811":"e20617f1","876":"ec98f7f0"}[chunkId] + ".css";
};